import { option, pipe } from '@code-expert/prelude';
import { NotAuthorized } from '/imports/ui/components/NotFound';

export const Unauthorised = ({ reason }: { reason: option.Option<string> }) =>
  pipe(option.toUndefined(reason), (text) => <NotAuthorized {...{ text }} />);
